import { WebStorageStateStore } from "oidc-client-ts";
import { AuthProviderProps } from "react-oidc-context";

import { env } from "src/env";

const authClients = {
  local: {
    client: "spa-fraud",
    realm: "/realms/anti-fraud",
  },
  dev: {
    client: "local-dev-front",
    realm: "/auth/realms/kyc",
  },
  prod: {
    client: "kyc-proxy-prod",
    realm: "/auth/realms/kyc",
  },
};

const selectedClient = authClients[env.auth];

export const authConfig: AuthProviderProps = {
  authority: selectedClient?.realm,
  client_id: selectedClient?.client,
  scope: "openid profile email",
  response_type: "code",
  accessTokenExpiringNotificationTimeInSeconds: 60,
  redirect_uri: window.location.origin,
  silent_redirect_uri: window.location.origin,
  automaticSilentRenew: true,
  revokeTokensOnSignout: true,
  stateStore: new WebStorageStateStore({ store: sessionStorage }),
  userStore: new WebStorageStateStore({ store: sessionStorage }),
  onSigninCallback: (): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
